module.exports = __webpack_public_path__ + "img/woori-crowd.2af33b19.png";